import {
  setYear,
  setMonth,
  setDate,
  format,
  parseISO,
  startOfDay,
  endOfDay,
  addDays,
} from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

const DAY_FORMAT = `yyyy-MM-dd`;

export function setSameDay(date: Date, toDate: Date) {
  date = setYear(date, toDate.getFullYear());
  date = setMonth(date, toDate.getMonth());
  date = setDate(date, toDate.getDate());

  return date;
}

export function parseDay(day: string, timeOfDay?: "start" | "end"): Date {
  const date = parseISO(day);

  if (timeOfDay === "start") {
    return startOfDay(date);
  } else if (timeOfDay === "end") {
    return endOfDay(date);
  }

  return date;
}

export function toDay(date: Date): string {
  return format(date, DAY_FORMAT);
}

/**
 * Today's date in the given IANA zone, as YYYY-MM-DD. The browser's own date is
 * the wrong floor for anything the backend judges in a location's zone: staff
 * in Vietnam working a US location are already on the next day during the US
 * afternoon, and would be refused the location's own today. Falls back to the
 * browser's date when no zone is known or the zone is not recognised.
 */
export function todayInTimeZone(timeZone: string): string {
  if (!timeZone) return toDay(new Date());
  try {
    return formatInTimeZone(new Date(), timeZone, DAY_FORMAT);
  } catch {
    return toDay(new Date());
  }
}

export function isValidDay(day: string): boolean {
  const date = parseDay(day);

  try {
    format(date, DAY_FORMAT);
    return true;
  } catch (error) {
    return false;
  }
}

export function getDates(startDate: string, endDate: string) {
  const startDateObj = parseDay(startDate);
  const endDateObj = parseDay(endDate);
  const dates = [];
  for (let date = startDateObj; date <= endDateObj; date = addDays(date, 1)) {
    dates.push(toDay(date));
  }
  return dates;
}
